import { Sport } from '__generated__/globalTypes';

export const CARDS_REQUIREMENTS_BY_SPORT = {
  [Sport.FOOTBALL]: 5,
  [Sport.BASEBALL]: 7,
  [Sport.NBA]: 5,
};
